const games_en = require('./games.json')
export default games_en
